import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { SignedIn, SignedOut, SignIn, useAuth } from '@clerk/clerk-react'
import { Sidebar } from '@/components/dashboard/Sidebar'
import { Header } from '@/components/dashboard/Header'
import { useQuery } from '@tanstack/react-query'
import { getSupabaseWithClerkAuth } from '@/lib/supabase'

const PAGE_TITLES: Record<string, string> = {
  '/dashboard': 'Overview',
  '/dashboard/models': 'Model Marketplace',
  '/dashboard/keys': 'API Keys',
  '/dashboard/usage': 'Usage Analytics',
  '/dashboard/billing': 'Billing',
  '/dashboard/playground': 'Playground',
  '/dashboard/settings': 'Settings',
}

function DashboardContent() {
  const location = useLocation()
  const { getToken } = useAuth()

  const title = PAGE_TITLES[location.pathname] || 'Dashboard'

  const { data: customer } = useQuery({
    queryKey: ['customer'],
    queryFn: async () => {
      const db = await getSupabaseWithClerkAuth(getToken)
      const { data, error } = await db
        .from('customers')
        .select('credit_balance_usd, currency_preference')
        .single()
      if (error) return null
      return data
    },
  })

  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar />

      {/* Main content */}
      <div className="lg:ml-64 flex flex-col min-h-screen">
        <Header
          title={title}
          balance={customer?.credit_balance_usd}
          currency={customer?.currency_preference || 'PHP'}
        />
        <main className="flex-1 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default function DashboardLayout() {
  return (
    <>
      <SignedIn>
        <DashboardContent />
      </SignedIn>
      <SignedOut>
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
          <div className="w-full max-w-md">
            <div className="text-center mb-8">
              <div className="flex items-center justify-center gap-2 mb-4">
                <img src="/logo.svg" alt="Neoserve" className="h-10 w-10" />
                <span className="text-2xl font-bold text-gray-900">Neoserve</span>
              </div>
              <p className="text-gray-500">Sign in to access your dashboard</p>
            </div>
            <SignIn
              routing="hash"
              afterSignInUrl="/dashboard"
              signUpUrl="/sign-up"
              appearance={{
                elements: {
                  rootBox: 'w-full',
                  card: 'shadow-xl rounded-2xl border border-gray-200',
                },
              }}
            />
          </div>
        </div>
      </SignedOut>
    </>
  )
}
